
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 21h5M16 15h12M16 27h3","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M30.328 25.332l-.405.878H24.32l.32-.878h5.688zm-.763 1.73l-.413.887H24.32l.32-.887h4.925zm1.803-4.044l-.503 1.079a3.64 3.64 0 00-.52-.371 2.753 2.753 0 00-.605-.264 2.297 2.297 0 00-.694-.103c-.455 0-.86.122-1.215.367-.355.244-.635.61-.84 1.1-.201.485-.302 1.09-.302 1.815 0 .724.1 1.33.302 1.815.205.486.485.85.84 1.095.355.242.76.362 1.215.362a2.4 2.4 0 00.698-.098c.22-.065.418-.15.597-.255.182-.108.345-.222.49-.341l.516 1.074c-.302.272-.651.478-1.049.617-.397.14-.815.21-1.252.21-.714 0-1.346-.181-1.897-.542-.548-.36-.979-.875-1.291-1.543-.313-.67-.469-1.468-.469-2.394 0-.93.157-1.73.469-2.4.313-.67.743-1.186 1.291-1.546.551-.361 1.183-.542 1.896-.542.455 0 .878.076 1.27.226.392.148.743.361 1.053.64z","fill":"#D07D01"}}),_c('path',{attrs:{"d":"M8 10c0-1.657 1.52-3 3.396-3h21.508C34.78 7 36.3 8.343 36.3 10v24c0 1.657-1.52 3-3.396 3H11.396C9.52 37 8 35.657 8 34V10z","stroke":"#363636","stroke-width":"1.5"}})])
          )
        }
      }
    